// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"09f17d84","498":"0c1154c4","703":"91e03516","787":"a33afc4b"}[chunkId] + ".chunk.js";
};